(() => {
  'use strict';

  /*
   * ============================================================
   * SCULTURE CUSTOM
   * Predictive Search for Dawn 16+
   * ============================================================
   *
   * Dawn標準 predictive-search.js は編集しない。
   *
   * 標準の PredictiveSearch クラスにある
   * getSearchResults() だけを後から上書きし、
   *
   * /search?view=live
   *
   * を使ってSCULTURE独自検索を表示する。
   *
   * PRODUCTS + BRANDS
   * ============================================================
   */


  const PredictiveSearchClass =
    customElements.get(
      'predictive-search'
    );


  /*
   * Predictive Searchが無効、
   * またはDawn側JSが読み込まれていない場合
   */
  if (!PredictiveSearchClass) {

    console.warn(
      '[SCULTURE Search] PredictiveSearch class was not found.'
    );

    return;

  }


  /*
   * 二重適用防止
   */
  if (
    PredictiveSearchClass
      .prototype
      .sctLiveSearchPatched
  ) {
    return;
  }


  PredictiveSearchClass
    .prototype
    .sctLiveSearchPatched =
      true;



  /* =========================================================
     LIVE SEARCH
     ========================================================= */

  PredictiveSearchClass
    .prototype
    .getSearchResults =
    function (
      searchTerm
    ) {

      const normalizedTerm =
        searchTerm.trim();


      if (!normalizedTerm) {

        this.close(
          true
        );

        return;

      }


      const queryKey =
        `sct-live-search-${normalizedTerm
          .replace(
            /\s+/g,
            '-'
          )
          .toLowerCase()}`;



      /*
       * 入力途中の古い通信をキャンセル
       */
      this.abortController.abort();


      this.abortController =
        new AbortController();


      const currentController =
        this.abortController;



      /*
       * Loading表示
       */
      this.setLiveRegionLoadingState();



      /*
       * Dawn16の
       * SearchUpdateEventも維持
       */
      const searchDeferred =
        typeof this
          .dispatchSearchUpdateEvent ===
          'function'

          ? this
              .dispatchSearchUpdateEvent(
                normalizedTerm
              )

          : null;



      /* =====================================================
         CACHE
         ===================================================== */

      if (
        this.cachedResults[
          queryKey
        ]
      ) {

        if (
          this.getQuery() ===
          normalizedTerm
        ) {

          this.renderSearchResults(
            this.cachedResults[
              queryKey
            ]
          );

        }


        searchDeferred
          ?.resolve({
            totalCount:
              this.querySelectorAll(
                '.sc-predictive-search__product'
              ).length,
          });


        return;

      }



      /* =====================================================
         SEARCH URL
         ===================================================== */

      const searchUrl =
        new URL(
          this.input.form.action,
          window.location.origin
        );


      /*
       * 検索語
       */
      searchUrl
        .searchParams
        .set(
          'q',
          normalizedTerm
        );


      /*
       * 商品のみ検索。
       *
       * Brand候補は
       * live-search-results.liquid側で
       * shop.vendorsから別途生成する。
       */
      searchUrl
        .searchParams
        .set(
          'type',
          'product'
        );


      /*
       * Shopify検索のprefix
       */
      searchUrl
        .searchParams
        .set(
          'options[prefix]',
          'last'
        );


      /*
       * SCULTURE専用template
       *
       * templates/search.live.json
       */
      searchUrl
        .searchParams
        .set(
          'view',
          'live'
        );



      /* =====================================================
         FETCH
         ===================================================== */

      fetch(
        searchUrl.toString(),
        {
          signal:
            currentController
              .signal,
        }
      )

        .then(
          response => {

            if (
              !response.ok
            ) {

              throw new Error(
                `SCULTURE live search request failed: ${response.status}`
              );

            }


            return response.text();

          }
        )


        .then(
          text => {

            /*
             * 検索中に入力文字が変わっていた場合、
             * 古い検索結果は表示しない。
             */
            if (
              currentController !==
                this.abortController
              ||
              this.getQuery() !==
                normalizedTerm
            ) {

              return;

            }



            const documentResult =
              new DOMParser()
                .parseFromString(
                  text,
                  'text/html'
                );



            /*
             * live-search-results.liquid
             */
            const resultsRoot =
              documentResult
                .querySelector(
                  '.sc-predictive-search'
                );


            if (!resultsRoot) {

              throw new Error(
                'SCULTURE live search results were not found.'
              );

            }



            /*
             * Shopify Sectionの中身を取得
             */
            const resultsSection =
              resultsRoot.closest(
                '.shopify-section'
              );


            if (!resultsSection) {

              throw new Error(
                'SCULTURE live search section was not found.'
              );

            }



            const resultsMarkup =
              resultsSection
                .innerHTML;



            /*
             * 複数のPredictive Searchがある場合
             * 全インスタンスでキャッシュ共有
             */
            this
              .allPredictiveSearchInstances
              .forEach(
                predictiveSearchInstance => {

                  predictiveSearchInstance
                    .cachedResults[
                      queryKey
                    ] =
                      resultsMarkup;

                }
              );



            /*
             * 最新検索語なら描画
             */
            if (
              currentController ===
                this.abortController
              &&
              this.getQuery() ===
                normalizedTerm
            ) {

              this.renderSearchResults(
                resultsMarkup
              );

            }



            /*
             * Dawn16 Standard Event用
             *
             * 最大6件表示なので
             * 表示中の商品数を返す。
             */
            const productCount =
              resultsRoot
                .querySelectorAll(
                  '.sc-predictive-search__product'
                )
                .length;


            searchDeferred
              ?.resolve({
                totalCount:
                  productCount,
              });



            /*
             * DEBUG
             */
            const query =
              new URLSearchParams(
                window.location.search
              );


            if (
              query.get(
                'sct_debug'
              ) === '1'
            ) {

              console.log(
                '[SCULTURE Search] results loaded',
                {
                  searchTerm:
                    normalizedTerm,

                  productCount,

                  brandCount:
                    resultsRoot
                      .querySelectorAll(
                        '.sc-predictive-search__collection'
                      )
                      .length,
                }
              );

            }

          }
        )


        .catch(
          error => {

            /*
             * 入力途中キャンセルは正常
             */
            if (
              error?.name ===
                'AbortError'
              ||
              error?.code ===
                20
            ) {

              searchDeferred
                ?.reject(
                  error
                );


              return;

            }


            searchDeferred
              ?.reject(
                error
              );


            this.close();


            console.error(
              '[SCULTURE Search]',
              error
            );

          }
        );

    };


  /*
   * DEBUG
   */
  const debugQuery =
    new URLSearchParams(
      window.location.search
    );


  if (
    debugQuery.get(
      'sct_debug'
    ) === '1'
  ) {

    console.log(
      '[SCULTURE Search] Dawn predictive search patched.'
    );

  }

})();